import { useState, useEffect } from "react";
import queryString from "query-string";
import { useTranslation } from "react-i18next";

import OAuthAuthorizeForm from "../components/OAuthAuthorizeForm";
import API_URL from "../components/ApiUrl";
import illustrationError from "./illustration_error.svg";

const GoogleHomeAuth = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [clientName, setClientName] = useState("");
  const [clientError, setClientError] = useState(false);
  const [redirecting, setRedirecting] = useState(false);

  const parsed = queryString.parse(window.location.search);
  const clientId = parsed.client_id;
  const redirectUri = parsed.redirect_uri;
  const state = parsed.state;

  useEffect(() => {
    if (!clientId || !redirectUri) {
      setClientError(true);
      setLoading(false);
      return;
    }
    fetch(`${API_URL}/oauth/client-info?client_id=${encodeURIComponent(clientId)}&redirect_uri=${encodeURIComponent(redirectUri)}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.json();
      })
      .then((data) => {
        setClientName(data.clientName);
      })
      .catch((error) => {
        console.error(error);
        setClientError(true);
      })
      .finally(() => setLoading(false));
  }, [clientId, redirectUri]);

  const handleAuthorized = (redirectUrl) => {
    setRedirecting(true);
    window.location.href = redirectUrl;
  };

  if (loading) {
    return (
      <div className="content">
        <p>Loading...</p>
      </div>
    );
  }

  if (clientError) {
    return (
      <div className="content">
        <img src={illustrationError} className="illustration-icon" alt={t('fail')} />
        <h1 style={{ fontSize: "36px", fontWeight: 600, color: "#4d4d4d" }}>{t('oauth.client_error.title')}</h1>
        <p style={{ fontSize: "18px", color: "#2b3136", textAlign: "center" }}>{t('oauth.client_error.body')}</p>
      </div>
    );
  }

  if (redirecting) {
    return (
      <div className="content">
        <p>{t('oauth.redirecting')}</p>
      </div>
    );
  }

  return (
    <div className="content">
      <h1 style={{ fontSize: "36px", fontWeight: 600, color: "#4d4d4d" }}>
        {t('oauth.title', { clientName })}
      </h1>
      <OAuthAuthorizeForm
        clientId={clientId}
        redirectUri={redirectUri}
        state={state}
        onAuthorized={handleAuthorized}
      />
    </div>
  );
};

export default GoogleHomeAuth;
